// extracted by mini-css-extract-plugin
export default {"inVisible":"DowngradeCard_inVisible__TjcJ9","invisbileIcon":"DowngradeCard_invisbileIcon__BUKrn","invisbileTitle":"DowngradeCard_invisbileTitle__8KNfR"};